import { DECIMAL_REG_EXP, FILTRATION_TYPES, INTEGER_REG_EXP } from 'constants/common';
import { FILTER_OPERATIONS_MAP } from 'constants/filterOperations';

import { FILTER_OPERATIONS } from './types';

export const INTL_MAPPING = {
  [FILTER_OPERATIONS.CONTAINS]: 'common.filters.contains',
  [FILTER_OPERATIONS.EQUALS]: 'common.filters.equals',
  [FILTER_OPERATIONS.EQUALS_NULL]: 'common.filters.equalsNull',
  [FILTER_OPERATIONS.IN]: 'common.filters.in',
  [FILTER_OPERATIONS.LESS_OR_EQUALS]: 'common.filters.lessOrEquals',
  [FILTER_OPERATIONS.LIKE]: 'common.filters.like',
  [FILTER_OPERATIONS.MORE_OR_EQUALS]: 'common.filters.moreOrEquals',
  [FILTER_OPERATIONS.NOT_EQUALS]: 'common.filters.notEquals',
  [FILTER_OPERATIONS.NOT_EQUALS_NULL]: 'common.filters.notEqualsNull',
  [FILTER_OPERATIONS.NOT_IN]: 'common.filters.notIn',
  [FILTER_OPERATIONS.NOT_LIKE]: 'common.filters.notLike',
  [FILTER_OPERATIONS.RANGE]: 'common.filters.range',
};

export const FILTRATION_ICONS = {
  [FILTER_OPERATIONS.CONTAINS]: <FILTER_OPERATIONS_MAP.Contains />,
  [FILTER_OPERATIONS.EQUALS]: <FILTER_OPERATIONS_MAP.Equals />,
  [FILTER_OPERATIONS.EQUALS_NULL]: <FILTER_OPERATIONS_MAP.Equals />,
  [FILTER_OPERATIONS.IN]: <FILTER_OPERATIONS_MAP.In />,
  [FILTER_OPERATIONS.LESS_OR_EQUALS]: <FILTER_OPERATIONS_MAP.LessOrEquals />,
  [FILTER_OPERATIONS.LIKE]: <FILTER_OPERATIONS_MAP.Contains />,
  [FILTER_OPERATIONS.MORE_OR_EQUALS]: <FILTER_OPERATIONS_MAP.MoreOrEquals />,
  [FILTER_OPERATIONS.NOT_EQUALS]: <FILTER_OPERATIONS_MAP.NotEquals />,
  [FILTER_OPERATIONS.NOT_EQUALS_NULL]: <FILTER_OPERATIONS_MAP.NotEquals />,
  [FILTER_OPERATIONS.NOT_IN]: <FILTER_OPERATIONS_MAP.NotIn />,
  [FILTER_OPERATIONS.NOT_LIKE]: <FILTER_OPERATIONS_MAP.NotContains />,
  [FILTER_OPERATIONS.RANGE]: <FILTER_OPERATIONS_MAP.Range />,
};

export const REG_EXP_VARIANTS = {
  [FILTRATION_TYPES.BIG_DECIMAL]: DECIMAL_REG_EXP,
  [FILTRATION_TYPES.DOUBLE]: DECIMAL_REG_EXP,
  [FILTRATION_TYPES.INTEGER]: INTEGER_REG_EXP,
  [FILTRATION_TYPES.LONG]: INTEGER_REG_EXP,
};

export const DICTIONARY_PREFIX = 'Dictionary';
export const ANALYTICS_DICTIONARY_PREFIX = 'AnalyticsDictionary';
export const AUTH_DICTIONARY_PREFIX = 'AuthDictionary';
export const BUILDER_DICTIONARY_PREFIX = 'BuilderDictionary';

export const PAYMENT_METHOD_KEY = 'paymentMethod';

export const MAX_PRESETS_LIMIT = 21;

export enum PRESET_IGNORE_FIELDS {
  CREATED = 'created',
  CREATION_DATE = 'creationDate',
  REGISTRATION_DATE = 'registrationDate',
}

export const PRESET_IGNORE_FIELDS_LIST = [
  PRESET_IGNORE_FIELDS.REGISTRATION_DATE,
  PRESET_IGNORE_FIELDS.CREATED,
  PRESET_IGNORE_FIELDS.CREATION_DATE,
];

export const ROLE_SCOPE = 'roleScope';

export const BASE_MERCHANT_SCOPE_ITEM = {
  fullAccess: false,
  id: null,
  merchantTerminals: [],
};
